import { render, staticRenderFns } from "./BrotherTwo.vue?vue&type=template&id=5617c7ad&scoped=true"
import script from "./BrotherTwo.vue?vue&type=script&lang=js"
export * from "./BrotherTwo.vue?vue&type=script&lang=js"
import style0 from "./BrotherTwo.vue?vue&type=style&index=0&id=5617c7ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5617c7ad",
  null
  
)

export default component.exports